
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		menberlevelList
	} from '@/utils/config';
	import {
		shareAndRetailStatis
	} from '@/api/agent_user';
	import {
		getSearchDate,
		nextDay
	}from "@/utils/index"

	@Component({
		name: 'share-retail-data',
		components: {
			PageFooter,
			PickerDate,
		}
	})
	export default class ShareRetailData extends Vue {
		private loading = false;
		private list: any = []
		private keywords = ''
		private roleGrade: any = null
		private gradeList = menberlevelList
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private defaultAvatar = 'https://cdn2024.shiwuzone.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png';
		private filterTime: any = ''

		private created() {
			this.filterTime = getSearchDate(1, true).join('/')
			this.getList();
		}

		private formatDate(date: Date): string {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		}

		private doSearch() {
			let dt = this.filterTime.split('/');
			const start = new Date(dt[0]).getTime();
			const end = new Date(dt[1]).getTime();
			const diff = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
			if (diff > 91) {
				this.$message.warning('时间范围最大可选92天');
				return;
			}
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.keywords = '';
			this.roleGrade = null;
			this.filterTime = getSearchDate(1, true).join('/')
			this.pageNo = 1;
			this.getList();
		}

		private async getList() {
			let dt = this.filterTime.split('/');
			const start = new Date(dt[0]).getTime();
			const end = new Date(dt[1]).getTime();
			const diff = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
			if (diff > 91) {
				this.$message.warning('时间范围最大可选92天');
				return;
			}

			let params: any = {
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				Keywords: this.keywords || null,
				RoleGrade: this.roleGrade
			};

			params.StartTime = dt[0];
			params.EndTime = dt[1];
			

			this.loading = true;
			try {
				const res: any = await shareAndRetailStatis(params);
				this.list = res.Result.Results || [];
				this.total = res.Result.Total || 0;
			} catch (e) {
				console.log(e);
			} finally {
				this.loading = false;
			}
		}

		private exportData() {
			let dt = this.filterTime.split('/');
			const start = new Date(dt[0]).getTime();
			const end = new Date(dt[1]).getTime();
			const diff = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
			if (diff > 91) {
				this.$message.warning('时间范围最大可选92天');
				return;
			}
			

			let url = location.origin + '/pc/member/shareAndRetailStatis?';
			url += 'Keywords=' + (this.keywords || '');
			url += '&RoleGrade=' + (this.roleGrade || '');
			url += '&StartTime=' + (dt[0] || '');
			url += '&EndTime=' + (dt[1] || '');
			console.log('Export URL:', url);
			window.open(url);
		}

		private changePage(page: number) {
			this.pageNo = page;
			this.getList();
		}
	}
